<template>
  <ReservationTop :shop="shop" :mode="mode" />
</template>

<script>
import { mapGetters } from 'vuex'
import ReservationTop from '@/components/ReservationTop'
export default {
  name: 'Home',
  components: {
    ReservationTop,
  },
  props: {
    mode: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    ...mapGetters(['shop']),
  },
}
</script>
